import logo from './logo.svg';
import './App.css';
// import Grid from '@nubank/nuds-web/components/Grid/Grid';
import Grid from '@nubank/nuds-web/components/DeprecatedGrid/DeprecatedGrid';

import Typography from '@nubank/nuds-web/components/Typography/Typography';
import NuLogo from '@nubank/nuds-web/components/NuLogo/NuLogo';
import Link from '@nubank/nuds-web/components/Link/Link';
import NuDSProvider from '@nubank/nuds-web/components/NuDSProvider/NuDSProvider';
import { nuDSColor } from '@nubank/nuds-web/styles/themeUtils'
import Box from '@nubank/nuds-web/components/Box/Box';
import Button from '@nubank/nuds-web/components/Button/Button';
import Image from '@nubank/nuds-web/components/Image/Image';
import React from 'react';
import Collapse from '@nubank/nuds-web/components/Collapse/Collapse';
import YouTube from 'react-youtube-embed'
// import Carousel from 'components/Carousel/Carousel';
import Footer from '@nubank/nuds-web/patterns/Footer/Footer';

import { StyledCenteredBox } from './styles/Box';

import 'react-sticky-header/styles.css';
import StickyHeader from 'react-sticky-header';

import SectionTestimonials from './SectionTestimonials';
import SectionFAQ from './SectionFAQ';
import SectionAreasCarrossel from './SectionAreasCarrossel';
import SectionSteps from './SectionSteps';
import SectionSteps2 from './SectionSteps2';
import SectionTrilhaCarrossel from './SectionTrilhaCarrossel';
import SectionValuesCarrossel from './SectionValuesCarrossel';

function App() {
	return (

		<NuDSProvider>

			{/* HEADER  LOGO + BOTAO */}
			<StickyHeader
				// This is the sticky part of the header.
				header={
					<Box
						tag="header"
						flex="1 100%"
						padding="1px"
						backgroundColor="white.default"
						boxShadow="rgb(27 27 27 / 20%) 0px 1px 5px;"
					// borderBottom="1px solid rgb(27 27 27 / 30%)"
					>
						<Grid
							row
							alignItems="center"
							justify="space-between"
							spacingHorizontal={{
								xs: '4x',
								md: '8x',
								lg: '1x',
							}}
						>
							<Grid
								col={{
									xs: 2,
									sm: 2,
									lg: 1,
									xl: 1,
								}}
								offset={{
									xs: 0,
									sm: 0,
									lg: 1,
									xl: 1,
								}}
							>

								<NuLogo
									// height='40'
									justify="right"
									variant="primary"
								/>
							</Grid>

							{/*.      GRID DO BOTAO DE INSCRICAO.    */}
							<Grid
								offset={{
									xs: 1,
									sm: 1,
									lg: 1,
									xl: 1,
								}}

								col=
								{{
									xs: 'auto',
									sm: 'auto',
									lg: 3,
									xl: 3,
								}}
								spacingRight={{
									xs: "2x",
									sm: "4x"
								}}

							>
								<Button
									variant="contained"
									styleVariant="primary"
									iconProps={{ name: 'arrow-right', title: 'Candidate-se' }}
									id="candidateButton"
									onClick={(e) => {
										e.preventDefault();
										window.open("https://grnh.se/b3ab14b61us", "_blank");
									}}
								>
									Candidate-se
								</Button>

							</Grid>
						</Grid>
					</Box>
				}
			>
				<Box marginTop={{ xs: '40px', md: '60px', lg: '80px' }} />

			</StickyHeader>

			{/*      Division line      */}
			<Box
				display="grid"
				paddingHorizontal={{ xs: '4x', md: '6x', lg: '12x' }}
				paddingTop={{ xs: '13vh', sm: '12vh', lg: '20vh' }}
				paddingBottom={{ xs: '12x', lg: '10x' }}
				minHeight={{ xs: '30vh', sm: '40vh', md: '55vh', lg: '80vh' }}

				gridColumnGap={{ xs: '4x', md: '8x', lg: '12x' }}
				gridRowGap={{ xs: '8x', md: '12x', lg: '10x' }}
				alignItems={{
					xs: 'flex-end',
					md: 'flex-end',
					lg: 'center'
				}}

				backgroundColor="white.dark"
				backgroundImage={{ xs: '/img/banner_site2024_1920x832.png', md: '/img/banner_site2024_1920x832.png' }}
				backgroundSize="contain" //"cover"
				backgroundRepeat="no-repeat" // Added backgroundRepeat property
				backgroundPosition={{ xs: 'left', md: "center" }}
			>
				<Grid
					col="fill"
					spacingRight="4x"
					spacingLeft="2x"
				>

					<Box
						paddingTop={{ xs: '5vh', lg: '20vh' }}

						paddingLeft='10px'
						alignSelf='flex-end'
					>
					</Box>
				</Grid>
			</Box>


			<Grid
				row
				coll="fill"
				tag="header"
				spacingVertical={{
					xs: '1x',
					md: '1x',
					lg: '1x',
				}}
				backgroundColor="white.default" />

			<Grid
				row
				tag="section"
				alignItems="center"
				spacingHorizontal={{
					xs: '4x',
					md: '8x',
					lg: '24x',
				}}
				spacingVertical={{
					xs: '6x',
					md: '6x',
					lg: '12x',
				}}
			>

				<Grid
					offset={{ lg: 1.5 }}
					col={{
						xs: 12,
						lg: 9,
						xl: 9,
					}}
				>
					<Typography
						variant="heading3"
						gutterBottom={1.5}
						color="primary"
						textAlign="center"
					>
						O Jeito Nu de começar.
					</Typography>

					<Typography
						variant="paragraph1"
						gutterBottom={1.5}
						textAlign="center"
					>
						Vamos formar uma nova geração de pessoas que continuarão a revolucionar o mercado financeiro e libertar as pessoas da complexidade financeira. <br />Conheça o nosso programa de estágio e comece, do Jeito Nu, a sua carreira.
					</Typography>
				</Grid>
			</Grid>

			{/*      Division line      */}

			<Grid
				row
				coll="fill"
				tag="header"
				spacingVertical={{
					xs: '1x',
					md: '1x',
					lg: '1x',
				}}
				backgroundColor="primary.default" />

			<Grid
				row
				coll="fill"
				tag="header"
				spacingVertical={{
					xs: '1x',
					md: '1x',
					lg: '1x',
				}}
				backgroundColor="white.default" />




			{/*    SECTION DE O QUE FAZ UM BA.   */}
			<Grid
				row
				tag="section"
				alignItems="center"
				spacingHorizontal={{
					xs: '4x',
					md: '8x',
					lg: '18x',
				}}
				spacingVertical={{
					xs: '6x',
					md: '6x',
					lg: '12x',
				}}

			>
				{/*     GRID DO VIDEO iFrame YT  >>>TODO: auto scale  */}
				<Grid
					spacingVertical={{ xs: '6x', lg: '4x' }}
					col={{
						xs: 12,
						lg: 5,
						xl: 6,
					}}
					spacingHorizontal={{
						xs: '4x',
						md: '8x',
						lg: '18x',
					}}
				>

					<YouTube id='HyabHuoNqpI' />
					{/* <iframe id='video' width="100%" height="100%" src="https://www.youtube.com/embed/SltbtJfFZGM" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe> */}
				</Grid>

				<Grid
					offset={{ lg: 0 }}

					col={{
						xs: 12,
						lg: 6,
						xl: 6,
					}}
				>

					<Typography
						variant="heading3"
						gutterBottom={1.5}
					>
						Programa de Estágio 2024, o jeito Nu de começar!
					</Typography>
					<Typography
						variant="paragraph1"
						gutterBottom={1.5}
					>
						As inscrições para o terceiro programa de estágio do Nubank foram encerradas em março de 2024. Foram vagas de estágio nas nossas áreas de tecnologia: Análise de Negócios, Engenharia de Software e Ciência de Dados.
						<br />Nos acompanhe nas redes sociais para ficar por dentro das próximas edições!
					</Typography>
					<Link
						variant="action"
						href="https://blog.nubank.com.br/estagio-nubank-2024"
					>
						Saiba mais!
					</Link>

				</Grid>


			</Grid>

			{/*      Division line      */}

			<Grid
				row
				coll="fill"
				tag="header"
				spacingVertical={{
					xs: '1x',
					md: '1x',
					lg: '1x',
				}}
				backgroundColor="primary.default" />
			{/*Seção de perfil do candidato*/}
			<Grid
				row
				tag="section"
				alignItems="center"

				spacingHorizontal={{
					xs: '4x',
					md: '8x',
					lg: '24x',
				}}
				spacingVertical={{
					xs: '6x',
					md: '6x',
					lg: '12x',
				}}
			>

				<Grid
					offset={{ lg: 1.5 }}
					col={{
						xs: 12,
						lg: 9,
						xl: 9,
					}}
				>
					<Typography
						variant="heading3"
						gutterBottom={1.5}
						color="primary"
						textAlign="center"
					>
						Em que áreas posso atuar?
					</Typography>

					<Typography
						variant="heading4"
						gutterBottom={1.5}
						textAlign="center"
					>
						Serão vagas para Análise de Negócios, Engenharia de Software e Ciência de Dados.
						<br />As pessoas aprovadas trabalharão em projetos que impactam diretamente a vida dos nossos clientes e o futuro do Nubank.

					</Typography>

				</Grid>

			</Grid>
			{/*      Division line      */}
			<SectionAreasCarrossel />

			<Grid row coll="fill" tag="header" spacingVertical={{ xs: '1x', md: '1x', lg: '1x', }} backgroundColor="primary.default" />


			<Box
				tag="section"
				paddingBottom={{ xs: '12x', md: '10x' }}
				alignItems={{
					md: 'flex-end',
					lg: 'center'
				}}
			>

				<Box
					paddingHorizontal={{ xs: '6x', md: '12x', lg: 56 }}
					marginTop={{ xs: '8x', md: '12x', lg: '20x' }}
					display={{ lg: 'grid' }}
					gridTemplateColumns={{ lg: 'repeat(12,1fr)' }}
					gridColumnGap={{ lg: '8x' }}
				>
					<Box
						gridColumn={{ lg: '3 / 11' }}
						marginHorizontal={{ md: 'auto' }}
						justify='center'
						alignItems='center'
					>
						<Typography
							variant="heading3"
							marginBottom={{ xs: '6x' }}
							marginHorizontal={{ md: 'auto' }}
							maxWidth={{ xs: '12ch', lg: 'none' }}
							textAlign={{ md: 'center' }}
						>
							E o que preciso para participar?
						</Typography>
						<Typography
							variant="paragraph1"
							marginHorizontal={{ md: 'auto' }}
							textAlign={{ md: 'left' }}
							gutterBottom={1.5}
						>
							<ul>
								<li >• Ter matrícula ativa em um curso superior (bacharelado, licenciatura ou tecnólogo) em universidade brasileira, sem restrição de cursos;</li>
								<li >• Previsão de formação entre Dezembro de 2025 a Julho de 2026;</li>
								<li >• Inglês a partir do nível Intermediário; </li>
								<li >• Disponibilidade para estagiar 30 horas semanais (6h/dia) no Brasil entre Agosto de 2024 e Dezembro 2025;</li>
								<li >• Morar no estado de São Paulo;</li>
								<li >• Ter disponibilidade para estagiar seguindo o modelo de trabalho híbrido do Nubank (Nu Way of Working).</li>
							</ul>
						</Typography>


					</Box>
				</Box>
			</Box>

			<SectionSteps />
			<Grid row coll="fill" tag="header" spacingVertical={{ xs: '1x', md: '1x', lg: '1x', }} backgroundColor="primary.default" />

			<Box
				tag="section"
				paddingBottom={{ xs: '12x', md: '10x' }}
				alignItems={{
					md: 'flex-end',
					lg: 'center'
				}}
			>

				<Box
					paddingHorizontal={{ xs: '6x', md: '12x', lg: 56 }}
					marginTop={{ xs: '8x', md: '12x', lg: '20x' }}
					display={{ lg: 'grid' }}
					gridTemplateColumns={{ lg: 'repeat(12,1fr)' }}
					gridColumnGap={{ lg: '8x' }}
				>
					<Box
						gridColumn={{ lg: '3 / 11' }}
						marginHorizontal={{ md: 'auto' }}
						justify='center'
						alignItems='center'
					>
						<Typography
							variant="heading3"
							marginBottom={{ xs: '6x' }}
							marginHorizontal={{ md: 'auto' }}
							maxWidth={{ xs: '12ch', lg: 'none' }}
							textAlign={{ md: 'center' }}
						>
							Benefícios
						</Typography>
						<Typography
							variant="paragraph1"
							marginHorizontal={{ md: 'auto' }}
							textAlign={{ md: 'left' }}
							gutterBottom={1.5}
						>
							<ul>
								<li >• Cartão Alimentação/Refeição;</li>
								<li >• Auxílio transporte;</li>
								<li >• Plano de saúde, odontológico e seguro de vida; </li>
								<li >• Onsite Health Center - Suporte médico para cada Nubanker em nosso escritório;</li>
								<li >• NuCare - Nosso programa de assistência em saúde mental e bem-estar;</li>
								<li >• Licença parental estendida;</li>
								<li >• Programa de cuidados infantis e assistência parental;</li>
								<li >• Núcleo - Nossa plataforma de aprendizagem de cursos;</li>
								<li >• NuLanguage - Nosso programa de aprendizado de idiomas;</li>
								<li >• Parcerias com academias.</li>
							</ul>
						</Typography>


					</Box>
				</Box>
			</Box>
			<SectionSteps2 />



			<Grid row coll="fill" tag="header" spacingVertical={'1x'} backgroundColor="white.default" />
			<Grid row coll="fill" tag="header" spacingVertical={'1x'} backgroundColor="white.default" />

			<Box
				// gridColumn={{ lg: '3 / 11' }}
				marginHorizontal={'auto'}
				justify='center'
				alignItems='center'
				backgroundColor="white.default"
			>
				<Typography
					variant="heading3"
					marginBottom={{ xs: '6x' }}
					marginHorizontal={{ md: 'auto' }}
					maxWidth={{ xs: '12ch', lg: 'none' }}
					textAlign={'center'}
				>
					Nossos Valores
				</Typography>

				<SectionValuesCarrossel />

			</Box>


			<Grid
				row
				tag="section"
				alignItems="center"
				spacingHorizontal={{ xs: '4x', md: '8x', lg: '24x', }}
				spacingVertical={{ xs: '4x', md: '4x', lg: '12x' }}
				backgroundColor="primary.default"
			>

				<Box
					tag="section"
					paddingBottom={{ xs: '12x', md: '10x' }}
					alignItems={{ md: 'flex-end', lg: 'center' }}
					backgroundColor="primary.default"

				>

					<Box
						paddingHorizontal={{ xs: '6x', md: '12x', lg: 56 }}
						marginTop={{ xs: '8x', md: '12x', lg: '20x' }}
						display={{ lg: 'grid' }}
						gridTemplateColumns={{ lg: 'repeat(12,1fr)' }}
						gridColumnGap={{ lg: '8x' }}
					>
						<Box
							gridColumn={{ lg: '3 / 11' }}
							marginHorizontal={{ md: 'auto' }}
							justify='center'
							alignItems='center'
						>
							<Typography
								variant="heading3"
								marginBottom={{ xs: '6x' }}
								marginHorizontal={{ md: 'auto' }}
								maxWidth={{ xs: '12ch', lg: 'none' }}
								textAlign={{ md: 'center' }}
								color="white.dark"
							>
								Sobre o Nubank
							</Typography>
							<Typography
								variant="paragraph1"
								marginHorizontal={{ md: 'auto' }}
								textAlign={{ md: 'center' }}
								gutterBottom={1.5}
								color="white.dark"
							>
								O Nubank nasceu em 2013 com a missão de lutar contra a complexidade para empoderar pessoas diariamente, reinventando os serviços financeiros.
								<br />
								Somos uma das maiores plataformas de serviços financeiros digitais no mundo, servindo mais de 90 milhões de clientes no Brasil, México e Colômbia. Usamos tecnologia proprietária e práticas inovadoras para criar novas soluções e experiências financeiras.
							</Typography>


						</Box>
					</Box>
				</Box>
			</Grid>
			{/* <Grid row coll="fill" tag="header" spacingVertical={{ xs: '1x', md: '1x', lg: '1x', }} backgroundColor="primary.default" /> */}


			<SectionFAQ />


		</NuDSProvider>
	);

}
// a
export default App;
